export const HOME = '/';
export const DASHBOARD = '/dashboard';

export const NEW_ORDER = '/new-order';

export const PROPERTY_SUMMARY = '/property/summary/:psId';
export const PROPERTY_DETAILS = '/property/details/:psId';

export const ACCOUNT_SETTINGS = '/account/settings';
